import { inject, Injectable } from '@angular/core';
import { AnalyticService } from '@core/entity/analytics/analytic-tracking';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { AllAnalyticActions } from './analytics.actions';

@Injectable()
export class AnalyticsEffects {
  private actions$ = inject(Actions);
  private analyticService = inject(AnalyticService);

  trackEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(...AllAnalyticActions),
        tap(({ category, action, name, value }) => {
          this.analyticService.trackEvent({ category, action, name, value });
        }),
      ),
    { dispatch: false },
  );
}
